import {
  Avatar,
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  HStack,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Textarea,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { MyTestimonialsContext } from '../context';
import {
  getUserFullName,
  getUserPosition,
  getUserProfilePic,
} from 'v4/lib/commons';
import { Controller, useForm } from 'react-hook-form';
import { ConnectionsDropdown } from 'v4/components/connections-dropdown';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
export const MyTestimonialsAskTestimonialModal = forwardRef(
  ({ ...props }, ref) => {
    const {
      userProfileInfo,
      askTestimonialMutation,
      askTestimonialDisc,
      askTestimonial,
      selected,
    } = useContext(MyTestimonialsContext);
    const { t } = useTranslator();
    const { formatNumber } = useNumberFormatter();

    const {
      handleSubmit,
      register,
      control,
      watch,
      formState: { errors },
    } = useForm({
      defaultValues: {
        message: selected?.message,
      },
    });

    const onSubmit = (form) => {
      askTestimonial({
        ...form,
        form_type: 'ASK',
        id: selected?.id,
      });

    };
    return (
      <Modal size="2xl" {...props}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalHeader>
              <Heading color='#3D5A80' size="md">{t('profileTestimonials.askForTestimonial') || "Ask for a Testimonial"}</Heading>
              <ModalCloseButton />
            </ModalHeader>
            <ModalBody>
              <Stack spacing={4} flex={1}>
                <FormControl>
                  <Controller
                    render={({ field }) => <ConnectionsDropdown type={"ask"} max={3} {...field} />}
                    name="giver"
                    control={control}
                    rules={{ required: true }}
                  />
                </FormControl>
                <FormControl isInvalid={errors?.message}>
                  <FormLabel>
                    {t('profileTestimonials.writeMessage') || "Write a message to"} {getUserFullName(selected?.asker)} {t('profileTestimonials.toSendWithTestimonial') || "to send with your testimonial."}
                  </FormLabel>
                  <Textarea
                    // defaultValue={`Can you please give me testimonial.`}
                    placeholder={t('profileTestimonials.exampleTestimonialRequest') || `Hello Jill. I would love it if you would write a testimonial detailing our time working together at BB Law Firm. Thanks! Karen`}
                    // {...register('message', { required: true })}
                    {...register('message', { 
                      required: true,
                      maxLength: {
                        value: 100,
                        message: t('profileTestimonials.messageCharacterLimit') || 'Message must be 100 characters or less'
                      }
                    })}
                    maxLength={100}
                  />
                  <Text
                    color="#5B5B5B"
                    fontSize="12px"
                    textAlign="right"
                    fontWeight={400}
                  >
                    {/* {watch('message')?.length  || 0}/{100} */}
                    {formatNumber(watch('message')?.length || 0)}/{formatNumber(100)}
                  </Text>
                  {watch('message')?.length >= 100 && (
                    <Text mb={2} fontSize="14px" color="red.500">
                      {' '}
                      {'Message must be 100 characters or less'}
                    </Text>
                  )}
                  <FormErrorMessage>{t('profileTestimonials.messageIsRequired') || "Message is required"}</FormErrorMessage>
                </FormControl>
              </Stack>
            </ModalBody>
            <ModalFooter>
              <HStack justifyContent="flex-end">
                <Button
                  borderRadius="40px"
                  onClick={(e) => askTestimonialDisc?.onClose?.()}
                  variant="secondary"
                >
                  {t('buttons.cancel') || 'Cancel'}
                </Button>
                <Button
                  borderRadius="40px"
                  isLoading={askTestimonialMutation?.isLoading}
                  type="submit"
                  variant="primary"
                  isDisabled={ watch('giver')?.length === 0}
                >
                  {t('buttons.send') || 'Send'}
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    );
  }
);
